'use client';

import * as React from 'react';
import { cn } from '../lib/utils';

export function Tabs({
  value,
  onValueChange,
  items,
  className,
}: {
  value: string;
  onValueChange: (value: string) => void;
  items: Array<{ value: string; label: string }>;
  className?: string;
}) {
  return (
    <div
      role="tablist"
      className={cn(
        'inline-flex flex-wrap gap-1 rounded-md-token border border-border bg-surface-muted p-1',
        className,
      )}
    >
      {items.map((item) => (
        <button
          key={item.value}
          type="button"
          role="tab"
          aria-selected={value === item.value}
          onClick={() => onValueChange(item.value)}
          className={cn(
            'rounded-sm-token px-3 py-1.5 text-sm font-medium transition-colors transition-fast',
            value === item.value
              ? 'bg-surface text-text shadow-sm'
              : 'text-text-muted hover:text-text',
          )}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export function FilterBar({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-end gap-3 rounded-md-token border border-border bg-surface px-4 py-3',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function Logo({
  className,
  size = 'md',
  variant = 'full',
}: {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'full' | 'mark';
}) {
  const sizes = {
    sm: { full: 'h-8 w-auto max-w-[120px]', mark: 'h-6 w-6' },
    md: { full: 'h-10 w-auto max-w-[148px]', mark: 'h-8 w-8' },
    lg: { full: 'h-14 w-auto max-w-[200px]', mark: 'h-10 w-10' },
  };
  const s = sizes[size];
  const src = variant === 'mark' ? '/favicon.ico' : '/logo.png';

  return (
    <img
      src={src}
      alt="MPANGE"
      className={cn('object-contain', variant === 'mark' ? s.mark : s.full, className)}
    />
  );
}
